/*
 *
 * ResetPassword actions
 *
 */

import { createAction } from '@reduxjs/toolkit';
import { RESET_PASSWORD, RESET_RESET_PASSWORD } from './constants';

export const resetPasswordAct = createAction(
  RESET_PASSWORD,
  (loadingState, data) => ({
    payload: {
      loadingState,
      data,
    },
  }),
);
export const resetResetPasswordAct = createAction(RESET_RESET_PASSWORD);
